import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const swiper = new Swiper('.review-slider', {
    modules: [Navigation, Pagination],
    // Optional parameters
    direction: 'horizontal',

    loop: true,
    slidesPerView:1,
    spaceBetween: 5,
    breakpoints: {

        480: {
            slidesPerView: 1.2,
            spaceBetween: 5
        },



        831: {
            slidesPerView: 2,
            spaceBetween: 5
        }
    },



    // Navigation arrows
    navigation: {
        nextEl: '.pastel-landing-next',
        prevEl: '.pastel-landing-prev',
    },
});



const demoSlider = new Swiper('.demo-slider', {
    modules: [Navigation, Pagination],
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    slidesPerView:1,
    draggable: false,
    spaceBetween: 5,
    breakpoints: {
        480: {
            slidesPerView: 1,
            spaceBetween: 5,
            touchRatio: 0
        },
        831: {
            slidesPerView: 1,
            spaceBetween: 5,
            touchRatio: 0
        }
    },
    // Navigation arrows
    navigation: {
        nextEl: '.pastel-demo-next',
        prevEl: '.pastel-demo-prev',
    },
});


document.addEventListener('DOMContentLoaded', function() {

    const playButton = document.querySelector('.play-btn-purple--base');
    if (!playButton) {
        return;
    }

    playButton.addEventListener('click', function() {
        const videoId = document.querySelector('.video-modal-content').getAttribute('data-video');
        const videoUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', videoUrl);
        iframe.setAttribute('width', '100%');
        iframe.setAttribute('height', '100%');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', true);

        // Close button HTML
        const closeButtonHtml = `<div class="video-modal-close "><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.56482 15.2497L0.751221 14.4361L7.18651 8.00084L0.751221 1.56556L1.56482 0.751953L8.00011 7.18724L14.4354 0.751953L15.249 1.56556L8.81371 8.00084L15.249 14.4361L14.4354 15.2497L8.00011 8.81445L1.56482 15.2497Z" fill="#212240"/></svg></div>`;

        // Clear previous content and append new iframe and close button
        const modalContent = document.querySelector('.video-modal-content');
        modalContent.innerHTML = closeButtonHtml;
        modalContent.appendChild(iframe);
        document.querySelector('.video-modal').style.display = 'flex';

        // Add click event listener to the newly added close button
        document.querySelector('.video-modal-close').addEventListener('click', function() {
            document.querySelector('.video-modal').style.display = 'none';
            modalContent.innerHTML = ''; // Clear the modal content
        });
    });
});

